import type { DashboardRowType } from '@shared/types/Dashboard';

export const homeCoalitionDashboardRows: DashboardRowType[] = [
  {
    items: [
      {
        rowSpan: 2,
        colSpan: 3,
        elementId: 16,
      },
    ],
  },
  {
    items: [
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 17,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 18,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 19,
      },
    ],
  },
];
